import { FC } from 'react'
import { Box, Radio } from '@mui/material'
import { MainButton, Typography } from '@eventr/common-storybook'
import {
    SERPRegionRequestDtoSortByPref,
    SERPRegionRequestDtoSortByPrefList,
} from '@eventr/common'
import i18n from '../../../i18n/i18next'
import { useEphemeralStore } from '../../../state/useEphemeralStore'
import { useShallow } from 'zustand/react/shallow'

type TSortDrawerProps = {
    close: () => void
}

function selectFieldMapNames(id: SERPRegionRequestDtoSortByPref) {
    switch (id) {
        case 'recommendedAsc':
            return 'Recommended'
        case 'priceAsc':
            return 'Price Ascending'
        case 'priceDesc':
            return 'Price Descending'
        case 'ratingAsc':
            return 'Rating'
    }
}

export const SortDrawer: FC<TSortDrawerProps> = ({ close }) => {
    const { sortByPreference, setSortByPreference } = useEphemeralStore(
        useShallow((s) => ({
            sortByPreference: s.sortByPreference,
            setSortByPreference: s.setSortByPreference,
        }))
    )
    return (
        <Box display={'grid'} width={'100%'}>
            <Box display={'grid'} justifyItems={'center'}>
                <Typography variant="bodyBold">
                    {i18n.t('booking.sort')}
                </Typography>
            </Box>

            <Box height={'16px'} />

            {SERPRegionRequestDtoSortByPrefList.map((sortItem, index) => {
                return (
                    <Box key={index}>
                        <Box
                            display={'grid'}
                            gridTemplateColumns={'1fr auto'}
                            onClick={() => {
                                setSortByPreference(sortItem)
                            }}
                        >
                            <Typography>
                                {selectFieldMapNames(sortItem)}
                            </Typography>
                            <Radio checked={sortByPreference === sortItem} />
                        </Box>
                    </Box>
                )
            })}
            <Box height={'16px'} />
            <MainButton text={i18n.t('general.done')} onClick={close} />
            <Box height={'32px'} />
        </Box>
    )
}
